import React, { useState } from 'react';

const HelloWorld = () => {
    const [count, setCount] = useState(0);

    return (
        <>
            <h1>Rails 8 + React (Vite)</h1>
            <p>
                This is rendered by React.
            </p>

            <button
                onClick={() => setCount(count + 1)}
            >
                Count: {count}
            </button>
        </>
    )
}
export default HelloWorld;
